const BASE_URL = 'https://kaoguo-api.bankaoedu.com/api/v2'

export default BASE_URL;